var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditSmall({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Edit",
    d: "M11.886,3.125a.989.989,0,0,0-.7.29l-.88.88,1.4,1.4.88-.88a.989.989,0,0,0-.7-1.688ZM10.91,6.488l-1.4-1.4L3.889,10.713l-.524,1.923,1.923-.524Zm.167-4.327a2.114,2.114,0,0,1,2.3,3.448l-7.4,7.4a.562.562,0,0,1-.25.145l-3.016.823a.563.563,0,0,1-.691-.691l.823-3.016a.562.562,0,0,1,.145-.25l7.4-7.4A2.114,2.114,0,0,1,11.077,2.161Z",
    transform: "translate(-2 -2)",
    fill: "#888",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditSmall);
export default __webpack_public_path__ + "static/media/edit-small.6cee5d233c51856be286db1be7e737a7.svg";
export { ForwardRef as ReactComponent };